import React, { useContext, useEffect } from "react";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { axiosGet } from "../utils/AxiosUtils";
import Autocomplete from "@mui/material/Autocomplete";
import RefreshIcon from "@mui/icons-material/Refresh";
import { formatLabel, isComponentDisabled, isComponentVisible } from "../utils/SaitUtils";
import { Box, Checkbox, IconButton } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useSelector } from "react-redux";
import { ModuleContext } from "../utils/Constants";
import { useTheme, alpha } from "@mui/material/styles";

export default function SaitComboFilter(props) {
	const theme = useTheme();

	const defaultSize = "small";

	const [itemsCombo, setItemsCombo] = React.useState([]);
	const [loadingFind, setLoadingFind] = React.useState(false);

	const componentModule = useContext(ModuleContext);
	const objModArray = useSelector((state) => state["auth"]["objMod"]);
	const objMod = objModArray.find((objModObject) => objModObject.moduleName === componentModule && objModObject.idObject === props.objmod);

	useEffect(() => {
		// Serve perchè nelle combo multiple con defaultValues, i tags rimanevano vuoti
		// Sovrascrivo i value passati dal defaultValues con i relativi record caricati a database
		if (itemsCombo.length > 0) {
			if (props.findParameters) {
				if (props.multiple) {
					if (props.value?.[0]?.[props.name[0].comboName] || props.value?.[0]?.[props.name[0].comboName] === 0) {
						const newValues = itemsCombo.filter((item) => props.value.some((filtro) => Object.keys(filtro).every((key) => filtro[key] === item[key])));
						props.overrideValues(newValues);
					}
				}
			}
		}
	}, [itemsCombo]);

	useEffect(() => {
		setItemsForAutocomplete(props.items);
		// eslint-disable-next-line
	}, [JSON.stringify(props.items)]);

	/////// FIND A DB ///////
	useEffect(() => {
		if (props.findParameters && !props.disabled) {
			setLoadingFind(true);
		}
		// eslint-disable-next-line
	}, [JSON.stringify(props.findParameters), props.disabled]);

	useEffect(() => {
		if (loadingFind) {
			getItemsFindFunction();
		}
		// eslint-disable-next-line
	}, [loadingFind]);

	const getItemsFindFunction = async () => {
		const resp = await axiosGet(props.findParameters.findFunction, props.findParameters.findFilters, props.findParameters.orderBy);
		setItemsForAutocomplete(resp.rows);
		setLoadingFind(false);
	};
	////////////////////////////

	const setItemsForAutocomplete = (items) => {
		let autoCompleteArray = [];
		items?.forEach((item) => {
			let labelDescription = formatLabel(props.description, item);

			item.customOptionLabel = labelDescription;

			autoCompleteArray.push(item);
		});
		setItemsCombo(autoCompleteArray);
	};

	const handleOnChange = (newValue) => {
		props.onChange(newValue);
	};

	const getOptionLabel = (option) => {
		if (option.customOptionLabel) {
			return option.customOptionLabel;
		} else {
			// Cerco il record caricato corrispondente all'opzione (nelle multiple props.value è un array)
			const item = itemsCombo.find((row) => {
				return props.name.every((obj) => {
					return row[obj.comboName] === option?.[obj.comboName];
				});
			});
			return item ? item.customOptionLabel : "";
		}
	};

	const textFieldStyle = {
		position: "relative",
		"& .MuiOutlinedInput-root.Mui-disabled": {
			backgroundColor: alpha(theme.palette.text.primary, 0.05),
			borderRadius: 1,
		},
		"& .MuiOutlinedInput-root.Mui-disabled .MuiInputBase-input.Mui-disabled": {
			color: theme.palette.text.primary, // colore testo più scuro
			WebkitTextFillColor: theme.palette.text.primary, // forza colore su Chrome/Edge
			opacity: 0.8,
		},
		"& .MuiInputLabel-root.Mui-disabled": {
			color: theme.palette.text.secondary,
		},
	};

	return isComponentVisible(objMod, props.hidden) ? (
		<Autocomplete
			// Nelle combo dinamiche (filterOptions) gli items cambiano ad ogni digitazione: rimontare l'Autocomplete
			// farebbe perdere il focus e chiudere la combo
			key={props.filterOptions ? "dynamic" : itemsCombo.length > 0 ? "loaded" : "loading"}
			options={props.findParameters ? ["ReloadComboJsws", ...itemsCombo] : itemsCombo}
			sx={{
				...props.sx,
				...((props.limitTags === 1 || !props.limitTags) && {
					".MuiInputBase-root:not(:focus-within)": {
						height: "36.7px",
					},
				}),
			}}
			size={props.size || defaultSize}
			disabled={isComponentDisabled(objMod, props.disabled) || (!props.findParameters && props.items === null && !props.filterOptions) || loadingFind || props.disabled}
			value={
				props.multiple
					? props.value?.[0]?.[props.name[0].comboName] || props.value?.[0]?.[props.name[0].comboName] === 0
						? props.value
						: []
					: props.value[props.name[0].comboName] || props.value[props.name[0].comboName] === 0
					? props.value
					: null
			}
			onChange={(event, newValue) => handleOnChange(newValue)}
			isOptionEqualToValue={(option, value) => {
				return props.name.every((combo) => option[combo.comboName] === value[combo.comboName]);
			}}
			getOptionLabel={getOptionLabel}
			filterOptions={props.filterOptions}
			onInputChange={props.onInputChange}
			multiple={props.multiple || false}
			limitTags={props.limitTags || 1}
			disableCloseOnSelect={props.multiple ? true : false}
			renderInput={(params) => (
				<TextField
					{...params}
					required={props.required}
					label={props.label}
					error={props.error}
					size={props.size || defaultSize}
					variant={props.disabled ? "filled" : "outlined"}
					sx={textFieldStyle}
					slotProps={{
						input: {
							...params.InputProps,
							endAdornment: (
								<>
									{((!props.findParameters && props.items === null) || loadingFind) && !props.disabled && !props.filterOptions ? (
										<CircularProgress color="inherit" size={25} />
									) : null}
									{params.InputProps.endAdornment}
								</>
							),
						},
					}}
				/>
			)}
			renderOption={(renderProps, option, { selected }) => {
				// @ts-ignore
				let { key, limitTags, findParameters, ...restRenderProps } = renderProps;
				if (option === "ReloadComboJsws") {
					return (
						<Box
							key={"RELOAD"}
							component="li"
							{...restRenderProps}
							sx={{
								display: "flex", // forza il flex
								justifyContent: "center !important", // forza il centraggio
								padding: 0,
							}}
						>
							<IconButton
								size="small"
								onClick={() => {
									setLoadingFind(true);
								}}
							>
								<RefreshIcon />
							</IconButton>
						</Box>
					);
				} else {
					return (
						<li key={key} {...restRenderProps}>
							{props.multiple && <Checkbox icon={<CheckBoxOutlineBlankIcon fontSize="small" />} checkedIcon={<CheckBoxIcon fontSize="small" />} checked={selected} />}
							{getOptionLabel(option)}
						</li>
					);
				}
			}}
		/>
	) : null;
}
